export default __webpack_public_path__ + "static/WhyteInktrap-Black-531e20a734bfda5dbf5ca01b0d1f4046.woff";